/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { useEffect, useRef, useState } from "react";
import WebViewer from "@pdftron/webviewer";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import _ from "underscore";
import * as zoneActions from "../../../../store/actions/zoneActions";

const WebView = (props) => {
  const clientFileFormat = [
    "pdf",
    "doc",
    "docx",
    "xls",
    "xlsx",
    "ppt",
    "pptx",
    "jpg",
    "jpeg",
    "png",
    "zip",
  ];
  const clientAviFormat = ["mp4", "ogg", "wav", "mp3"];
  const customFileFormatForTiff = ["tiff", "tif"];
  const customFileFormatTxt = ["txt"];
  const customXMLFormat = ["xml"];
  const customHTMLFormat = ["html", "htm"];
  const webviewUnsupportedFile = ["bmp","txt","xml","zip"]
  let HtmlContent = "";
  const { fullDateTimePattern, dateLocale } = useSelector(
    (store) => store.template
  );

  let docViewer;
  const dispatch = useDispatch();

  const { apiInitConfigObj } = useSelector((store) => store.zone);
  const pdfLicense = atob(apiInitConfigObj.previewkey);
  const viewer = useRef(null);
  const { t } = useTranslation();

  const [zipList, setZipeList] = useState([]);
  const [htmlValue, setHtmlValue] = useState("");
  const [documentLoaded, setDocumentLoaded] = useState(true);
  const initialFormFields = useRef({});
  const formFields = useRef({});
  const selectedFormFieldName = useRef("");

  //using promises to wait for portfolio variable to update
  function waitForPortfolioCheck(instance) {
    return new Promise((resolve) => {
      instance.Core.documentViewer.addEventListener(
        "documentLoaded",
        async () => {
          setDocumentLoaded(false);
          instance.UI.disableElements(["saveButton"]);
          if (props.fileType === "pdf") {
            const { PDFNet, documentViewer } = instance.Core;
            await PDFNet.initialize();
            const pdfDoc = await documentViewer.getDocument().getPDFDoc();
            pdfDoc.initSecurityHandler();
            const files = await PDFNet.NameTree.find(pdfDoc, "EmbeddedFiles");
            const isPortfolio = !_.isEmpty(files);

            if (isPortfolio) {
              instance.UI.openElements(["leftPanel"]);
              instance.UI.setActiveLeftPanel("portfolioPanel");
            }

            instance.UI.addEventListener("onTabManagerReady", (e) => { 
              props.setIsPortfolioTabOpen(true);
            })

            instance.UI.addEventListener("tabDeleted", (e) => {
              if(!_.isEmpty(instance?.UI?.TabManager?.getAllTabs())) {
                props.setIsPortfolioTabOpen(true);
              } else {
                 props.setIsPortfolioTabOpen(false);
              }
            })

            resolve(isPortfolio);
          } else {
            resolve(false);
          }
        }
      );
    });
  }

  const doFileTypeAbbrevation = (filetype) => {
    let fileFullForm = "";
    let icon = "";
    switch (filetype) {
      case "pdf":
        fileFullForm = "Adobe Acrobat Document";
        icon = "file-pdf";
        break;

      case "xlsx":
        fileFullForm = "Microsoft Excel Worksheet";
        icon = "file-xls";
        break;

      case "xls":
        fileFullForm = "Microsoft Excel Worksheet";
        icon = "file-xls";
        break;

      case "docx":
        fileFullForm = "Microsoft Word Worksheet";
        icon = "file-doc";
        break;

      case "doc":
        fileFullForm = "Microsoft Word Worksheet";
        icon = "file-doc";
        break;

      case "jpg":
        fileFullForm = "JPG File";
        icon = "zip-file-preview";
        break;

      case "jepg":
        fileFullForm = "JPG File";
        icon = "zip-file-preview";
        break;

      case "apk":
        fileFullForm = "APK File";
        icon = "zip-file-preview";
        break;

      case "json":
        fileFullForm = "JSON Source File";
        icon = "zip-file-preview";
        break;

      case "txt":
        fileFullForm = "Text Document";
        icon = "file-default";
        break;

      case "mp4":
        fileFullForm = "MP4 File";
        icon = "zip-file-preview";
        break;

      case "rtf":
        fileFullForm = "Rich Text Format";
        icon = "file-default";
        break;

      case "xml":
        fileFullForm = "XML Document";
        icon = "file-default";
        break;

      case "bmp":
        fileFullForm = "BMP File";
        icon = "zip-file-preview";
        break;

      case "odt":
        fileFullForm = "Open Document Text";
        icon = "file-doc";
        break;

      case "ppt":
        fileFullForm = "Microsoft Powerpoint Presentation";
        icon = "file-ppt";
        break;

      case "pptx":
        fileFullForm = "Microsoft Powerpoint Presentation";
        icon = "file-ppt";
        break;

      case "sin":
        fileFullForm = "Visual Studio solution";
        icon = "zip-file-preview";
        break;

      case "tiff":
        fileFullForm = "TIFF File";
        icon = "zip-file-preview";
        break;

      case "png":
        fileFullForm = "PNG File";
        icon = "zip-file-preview";
        break;

      case "md":
        fileFullForm = "Markdown Source";
        icon = "zip-file-preview";
        break;

      case "yml":
        fileFullForm = "Yaml Source File";
        icon = "file-default";
        break;

      case "config":
        fileFullForm = "XML Configutation";
        icon = "zip-file-preview";
        break;

      case "zip":
        fileFullForm = "Compressed (zipped) Folder";
        icon = "file-zip";
        break;

      case "7z":
        fileFullForm = "7Z File";
        icon = "file-zip";
        break;

      case "ps1":
        fileFullForm = "Windows PowerShell Script";
        icon = "zip-file-preview";
        break;

      case "html":
        fileFullForm = "HTML Document";
        icon = "zip-file-preview";
        break;

      case "htm":
        fileFullForm = "HTML Document";
        icon = "zip-file-preview";
        break;

      default:
        fileFullForm = "File";
        icon = "zip-file-preview";
        break;
    }
    return { fileFullForm, icon };
  };

  const getPreviewFile = (zipFiles) => {
    let previewFileList = [];
    Object.keys(zipFiles).map((fileKeys) => {
      let dateModified = zipFiles[fileKeys].date;
      let { fileFullForm, icon } = doFileTypeAbbrevation(
        UtilsHelper.getFileExtension(zipFiles[fileKeys].name)
      );
      let fileExtension = fileFullForm;
      let fileCompressedSize =
        (zipFiles[fileKeys]._data.compressedSize / 1024).toFixed(2) < 1
          ? 1 + " KB"
          : zipFiles[fileKeys]._data.compressedSize === undefined
          ? zipFiles[fileKeys].dir
            ? ""
            : 0 + " KB"
          : Math.round(zipFiles[fileKeys]._data.compressedSize / 1024) + " KB";
      let createObject = {
        fileName: "",
        date: "",
        fileType: "",
        fileSize: "",
        fileIcon: "",
      };
      let fileName = zipFiles[fileKeys].name.split("/")[0];
      if (zipFiles[fileKeys].name.includes("/")) {
        if (
          _.isEmpty(
            previewFileList.filter((file) => file.fileName === fileName)
          )
        ) {
          createObject = {
            ...createObject,
            fileName: fileName,
            fileType: "File folder",
            fileIcon: "zip-folder-preview",
          };
          previewFileList.push(createObject);
        }
      } else {
        createObject = {
          ...createObject,
          fileName: fileName,
          date: UtilsHelper.momentLocalConversion(dateModified, true),
          fileType: fileExtension,
          fileSize: fileCompressedSize,
          fileIcon: icon,
        };
        previewFileList.push(createObject);
      }
    });
    return previewFileList;
  };

  const handleSaveAction = async () => {
    try {
      if (docViewer) {
        const annotManager = await docViewer.getAnnotationManager();
        const xfdfString = await annotManager.exportAnnotations(["widgets"]);
        !props.isNewVersionCreated ? dispatch(zoneActions.toPassModifiedData(xfdfString, true)) : dispatch(zoneActions.setDocNewVersionXfdfString(xfdfString));
      }
    } catch (error) {
      console.error("WebViewer instance not initialized.", error);
    }
  };

  const fieldSaveAction = (instance) => {
    handleSaveAction(); // Call the async function
    initialFormFields.current = {
      ...initialFormFields.current,
      ...formFields.current,
    };
    props.unSavedFormFields.current={};
    formFields.current = {};
    selectedFormFieldName.current = "";
    instance.UI.disableElements(["saveButton"]);
  };

  const triggerEvent = () => {
    const event = new MouseEvent("mouseup", {
      view: window,
      bubbles: true,
      cancelable: true,
    });

    document.dispatchEvent(event);
  };

  useEffect(() => {
    if (
      props.fileType &&
      (props.fileType.toLowerCase() === "mp4" ||
        props.fileType.toLowerCase() === "ogg" ||
        props.fileType.toLowerCase() === "webm")
    ) {
      WebViewer(
        {
          licenseKey: pdfLicense,
          path: "/lib",
          selectAnnotationOnCreation: true,
        },
        viewer.current
      ).then(async (instance) => {
        instance.Core.addEventListener("mouseover", (e) => {
          e.preventDefault();

          triggerEvent();
        });

        instance.UI.disableElements([
          "ribbons",
          "viewControlsButton",
          "leftPanelButton",
          "searchButton",
          "toggleNotesButton",
          "menuButton",
          "selectToolButton",
          "panToolButton",
          "toolsHeader",
        ]);
      });
    } else if (
      props.fileType &&
      (props.fileType.toLowerCase() === "wav" ||
        props.fileType.toLowerCase() === "mp3")
    ) {
      WebViewer(
        {
          path: "/lib",
        },
        viewer.current
      ).then(async (instance) => {
        // Extends WebViewer to allow loading media files (.mp3, .mp4, ogg, webm, etc.)
        instance.Core.documentViewer.addEventListener("mouseover", (e) => {
          e.preventDefault();

          triggerEvent();
        });
        instance.Core.documentViewer.addEventListener("documentLoaded", () => {
          setDocumentLoaded(false);
        });
        instance.UI.disableElements([
          "ribbons",
          "viewControlsButton",
          "leftPanelButton",
          "searchButton",
          "toggleNotesButton",
          "menuButton",
          "selectToolButton",
          "panToolButton",
          "toolsHeader",
        ]);
      });
    } else if (
      props.fileType &&
      customFileFormatForTiff.includes(props.fileType)
    ) {
      WebViewer(
        {
          licenseKey: pdfLicense,
          path: "/lib",
          css: "/lib/webviewCustomStyle.css",
          fullAPI: true,
        },
        viewer.current
      ).then(function (instance) {
        const iframeDoc = instance.UI.iframeWindow.document;
          const headerDOMElement = iframeDoc.querySelector(".HeaderItems");
          headerDOMElement.setAttribute(
            "style",
            "background-color: white !important; border: 0.5px solid #eaeaea; margin-right:0 !important;padding-right: 30px;"
          );
          const zoomOverlay = iframeDoc.querySelector(".zoom-overlay");
          zoomOverlay.setAttribute(
            "style",
            "background-color: white !important; margin-right: 0px;"
          );
         

          setTimeout(() => {
            const actionButtonElements = iframeDoc.querySelectorAll(
              ".App:not(.is-in-desktop-only-mode) .Header .HeaderItems button.ActionButton, .App:not(.is-in-desktop-only-mode) .Header .HeaderItems .tool-group-button"
            );
            for (
              let actionButtonIndex = 0;
              actionButtonIndex < actionButtonElements.length;
              actionButtonIndex++
            ) {
              const isMoreButton =
                actionButtonElements[actionButtonIndex].getAttribute(
                  "data-element"
                ) === "moreButton";
              actionButtonElements[actionButtonIndex].setAttribute(
                "style",
                `margin-left: ${
                  actionButtonIndex === 0 ? "11px" : "0px"
                } !important; margin-right: 11px !important; height: 32px; ${
                  isMoreButton ? "display: none;" : ""
                }`
              );
            }
          }, 10);

        instance.Core.documentViewer.addEventListener("mouseover", (e) => {
          e.preventDefault();

          triggerEvent();
        });
        instance.Core.documentViewer.addEventListener("documentLoaded", () => {
          setDocumentLoaded(false);
        });
        var FitMode = instance.Core.documentViewer.FitMode;
        instance.Core.documentViewer.setFitMode(FitMode.FitWidth);
        instance.UI.disableElements([
          "ribbons",
          "viewControlsButton",
          "leftPanelButton",
          "searchButton",
          "toggleNotesButton",
          "menuButton",
          "selectToolButton",
          "panToolButton",
          "toolsHeader",
        ]);
        var PDFNet = instance.Core.PDFNet;
        var newDoc;
        PDFNet.runWithoutCleanup(function () {
          //create an empty document
          return PDFNet.PDFDoc.create()
            .then(function (doc) {
              newDoc = doc;
              newDoc.initSecurityHandler();
              newDoc.lock();
              return PDFNet.Filter.createURLFilter(props.previewURL);
            })
            .then(function (tiffFile) {
              return PDFNet.Convert.fromTiff(newDoc, tiffFile);
            })
            .then(function () {
              newDoc.unlock();
              instance.Core.documentViewer.loadDocument(newDoc);
            })
            .catch(function () {
              setDocumentLoaded(false);
              instance.UI.showWarningMessage({
                message: t("TMF.TEXT_PREVIEWNOTAVAILABLE"),
              });
            })
        });
       
      });
    } else if (props.fileType && clientFileFormat.includes(props.fileType)) {
      if (props.fileType !== "zip") {
        WebViewer(
          {
            licenseKey: pdfLicense,
            path: "/lib",
            css: "/lib/webviewCustomStyle.css",
            fullAPI: true,
            disabledElements: [
              "applyFormFieldButton",
              "ribbon",
              "viewControlsButton",
              "leftPanelButton",
              "searchButton",
              "toggleNotesButton",
              "menuButton",
              "selectToolButton",
              "panToolButton",
              "toolsHeader",
              "ribbons",
              "undoButton",
              "redoButton",
              "SignatureFormField",
              "toolbarGroup-Edit",
              "toolbarGroup-Insert",
              "toolbarGroup-Shapes",
              "toolbarGroup-Annotate",
              "toolbarGroup-View",
              "toolbarGroup-FillAndSign",
              "signatureFieldToolGroupButton",
              "underlineToolGroupButton",
              "highlightToolGroupButton",
              "shapeToolGroupButton",
              "freeTextToolGroupButton",
              "freeHandHighlightToolGroupButton",
              "freeHandToolGroupButton",
              "stickyToolGroupButton",
              "squigglyToolGroupButton",
              "strikeoutToolGroupButton",
              "toolsOverlay",
              "eraserToolButton",
              "toolbarGroup-Forms",
              "listBoxFieldToolGroupButton",
              "comboBoxFieldToolGroupButton",
              "addReplyAttachmentButton",
              "annotationCommentButton",
              "annotationStyleEditButton",
              "copyTextButton",
              "documentControl",
              "freeHandHighlightToolButton",
              "freeHandToolButton",
              "freeTextToolButton",
              "highlightToolButton",
              "linkButton",
              "markInsertTextToolButton",
              "markReplaceTextToolButton",
              "multiDeleteButton",
              "multiGroupButton",
              "multiReplyButton",
              "multiSelectModeButton",
              "multiStateButton",
              "multiStyleButton",
              "notePopup",
              "noteState",
              "pageManipulationOverlayButton",
              "stickyToolButton",
              "textHighlightToolButton",
              "textSquigglyToolButton",
              "textStrikeoutToolButton",
              "textUnderlineToolButton",
              "thumbDelete",
              "thumbRotateClockwise",
              "zoomOverlay",
              "thumbnailsPanelButton",
              "outlinesPanelButton",
              "signaturePanelButton",
              "portfolioAddFile",
              "portfolioRenameButton",
              "portfolioDownloadButton",
              "portfolioDeleteButton",
            ],
          },
          viewer.current
        ).then(async (instance) => {
          instance.UI.enableFeatures([instance.UI.Feature.Portfolio]);
          instance.UI.setToolMode("AnnotationEdit");
          const iframeDoc = instance.UI.iframeWindow.document;
          const headerDOMElement = iframeDoc.querySelector(".HeaderItems");
          headerDOMElement.setAttribute(
            "style",
            "background-color: white !important; border: 0.5px solid #eaeaea; margin-right:0 !important;padding-right: 30px;"
          );

          const zoomOverlay = iframeDoc.querySelector(".zoom-overlay");
          zoomOverlay.style.backgroundColor = "white";
          zoomOverlay.style.marginLeft = "auto";
          zoomOverlay.style.marginRight = "0";

          const zoomIcons = zoomOverlay.querySelectorAll("button .Icon");
          zoomIcons.forEach((icon) => {
            icon.style.color = "black";
          });

          setTimeout(() => {
            const actionButtonElements = iframeDoc.querySelectorAll(
              ".App:not(.is-in-desktop-only-mode) .Header .HeaderItems button.ActionButton, .App:not(.is-in-desktop-only-mode) .Header .HeaderItems .tool-group-button"
            );
            for (
              let actionButtonIndex = 0;
              actionButtonIndex < actionButtonElements.length;
              actionButtonIndex++
            ) {
              const isMoreButton =
                actionButtonElements[actionButtonIndex].getAttribute(
                  "data-element"
                ) === "moreButton";
              actionButtonElements[actionButtonIndex].setAttribute(
                "style",
                `margin-left: ${
                  actionButtonIndex === 0 ? "11px" : "0px"
                } !important; margin-right: 11px !important; height: 32px; ${
                  isMoreButton ? "display: none;" : ""
                }`
              );
            }
          }, 10);

          instance.Core.documentViewer.addEventListener("mouseover", (e) => {
            e.preventDefault();

            triggerEvent();
          });
          waitForPortfolioCheck(instance).then((isPortfolio) => {

          var FitMode = instance.Core.documentViewer.FitMode;
          instance.Core.documentViewer.setFitMode(FitMode.FitWidth);
          let zoomControls;

          if (props.fileType === "pdf" && props.docStatus !== "Unpublished") {
            const { annotationManager, documentViewer } = instance.Core;
            documentViewer.addEventListener("annotationsLoaded", () => {
              const fieldManager = annotationManager.getFieldManager();
              fieldManager.getFields().forEach((field) => {
                field.flags.set("ReadOnly", true);
              });
            });
          }

          if (
            props.fileType === "pdf" &&
            props.docStatus === "Unpublished" &&
            props.writePermission && !isPortfolio
          ) {
            const { documentViewer, annotationManager } = instance.Core;
            annotationManager.addEventListener(
              "annotationSelected",
              (annotationList, action) => {
                //Workaround: Disable multi selection
                const selectedAnnotations =
                  annotationManager.getSelectedAnnotations();
                if (selectedAnnotations.length > 1) {
                  annotationManager.deselectAnnotation(selectedAnnotations[0]);
                }

                if (action === "selected" && annotationList.length) {
                  selectedFormFieldName.current =
                    annotationList[0].getCustomData("trn-form-field-name");
                } else {
                  selectedFormFieldName.current = "";
                }
              }
            );

            instance.UI.addEventListener("visibilityChanged", (e) => {
              const { element, isVisible } = e.detail;
              setTimeout(() => {
                if (element === "formFieldEditPopup" && isVisible) {
                  const okButton = iframeDoc.querySelector(
                    '[data-element="formFieldOK"]'
                  );
                  if (okButton) {
                    okButton.removeEventListener(
                      "click",
                      customFormFieldOKHandler
                    );
                    okButton.addEventListener(
                      "click",
                      customFormFieldOKHandler
                    );
                  }
                }
              }, 100);
            });

            const customFormFieldOKHandler = () => {
              const selectedAnnotations =
                annotationManager.getSelectedAnnotations();
              annotationManager.trigger("annotationChanged", [
                selectedAnnotations,
                "modify",
                {},
              ]);
              annotationManager.selectAnnotations([selectedAnnotations]);
            };

            const getAnnotationProperties = (annotation) => {
              const formFieldCreationManager =
                annotationManager.getFormFieldCreationManager();
              return {
                fieldName: formFieldCreationManager?.getFieldName(annotation) ? formFieldCreationManager?.getFieldName(annotation) : annotation?.fieldName,
                width: annotation?.Width,
                height: annotation?.Height,
                xAxis: annotation?.X,
                yAxis: annotation?.Y,
                styles: {
                  textColor: annotation?.Color?.toHexString() || null,
                  textFontSize: annotation?.FontSize || null,
                  textFillColor: annotation?.FillColor?.toHexString() || null,
                  strokeColor: annotation?.StrokeColor?.toHexString() || null,
                  strokeThickness: annotation?.StrokeThickness || null,
                  strokeStyle: annotation?.Style || null,
                },
                fieldProperties: {
                  showFieldIndicator:
                    formFieldCreationManager?.getShowIndicator(annotation),
                  fieldIndicator:
                    formFieldCreationManager?.getIndicatorText(annotation),
                  defaultFieldValue:
                    formFieldCreationManager?.getFieldValue(annotation),
                  flagMultiLine: formFieldCreationManager?.getFieldFlag(
                    annotation,
                    "trn-form-field-multi-line"
                  ),
                  flagReadOnly: formFieldCreationManager?.getFieldFlag(
                    annotation,
                    "trn-form-field-read-only"
                  ),
                  flagRequired: formFieldCreationManager?.getFieldFlag(
                    annotation,
                    "trn-form-field-field-required"
                  ),
                },
              };
            };

            annotationManager.addEventListener(
              "annotationChanged",
              (annotations, action, { imported }) => {
                // Set initial form fields
                if (imported && annotations.length) {
                  let annotationFields = { ...initialFormFields.current };
                  annotations.forEach((singleAnnotation) => {
                    const annotationProps =
                      getAnnotationProperties(singleAnnotation);
                    const { fieldName, width, height } = annotationProps;
                    const isValidField = fieldName && width > 0 && height > 0;
                    if (isValidField) {
                      annotationFields[fieldName] = annotationProps;
                    }
                  });

                  // Workaround fix: displaying formFieldEditPopup
                  setTimeout(() => {
                    const okButton = iframeDoc.querySelector(
                      '[data-element="formFieldOK"]'
                    );
                    okButton?.click();
                  });

                  initialFormFields.current = { ...annotationFields };
                  return;
                }

                const annotation = annotations[0];
                if (!annotation?.isFormFieldPlaceholder()) return;

                let annotationProps = getAnnotationProperties(annotation);
                const {
                  fieldName,
                  width,
                  height,
                  xAxis,
                  yAxis,
                  styles,
                  fieldProperties,
                } = annotationProps;
                const isValidField = fieldName && width > 0 && height > 0;
                if ((action === "add" || action === "modify") && isValidField) {
                  if(!_.isEmpty(initialFormFields.current) && Object.values(initialFormFields.current)?.length > 0 && action === "add"){
                  const isFieldExists =  Object.values(initialFormFields.current)?.find((field) =>  field.xAxis === xAxis &&  field.yAxis === yAxis)
                   if(isFieldExists) return;
                  }
                  // Check if the field name has changed
                  const oldInitialFormField = Object.keys(
                    initialFormFields.current
                  ).find(
                    (key) =>
                      initialFormFields.current[key].xAxis === xAxis &&
                      initialFormFields.current[key].yAxis === yAxis
                  );
                  if (
                    oldInitialFormField &&
                    oldInitialFormField !== fieldName
                  ) {
                    formFields.current = {
                      ...formFields.current,
                      ...initialFormFields.current[oldInitialFormField],
                    };
                    let existingFields = { ...initialFormFields.current };
                    delete existingFields[fieldName];
                    initialFormFields.current = {
                      ...existingFields,
                      [fieldName]: annotationProps,
                    };
                    selectedFormFieldName.current = fieldName;
                  }
                  const oldFieldName = Object.keys(formFields.current).find(
                    (key) =>
                      formFields.current[key].xAxis === xAxis &&
                      formFields.current[key].yAxis === yAxis
                  );
                  if (oldFieldName && oldFieldName !== fieldName) {
                    let existingFields = { ...formFields.current };
                    delete existingFields[oldFieldName];
                    formFields.current = {
                      ...existingFields,
                      [fieldName]: annotationProps,
                    };
                    selectedFormFieldName.current = fieldName;
                  }

                  // Difference checker
                  if (
                    initialFormFields.current[fieldName] &&
                    (initialFormFields.current[fieldName].width !== width ||
                      initialFormFields.current[fieldName].height !== height ||
                      initialFormFields.current[fieldName].xAxis !== xAxis ||
                      initialFormFields.current[fieldName].yAxis !== yAxis ||
                      JSON.stringify(
                        initialFormFields.current[fieldName].styles
                      ) !== JSON.stringify(styles) ||
                      JSON.stringify(
                        initialFormFields.current[fieldName].fieldProperties
                      ) !== JSON.stringify(fieldProperties))
                  ) {
                    formFields.current = {
                      ...formFields.current,
                      [fieldName]: annotationProps,
                    };
                  } else if (!(fieldName in initialFormFields.current)) {
                    formFields.current = {
                      ...formFields.current,
                      [fieldName]: annotationProps,
                    };
                  } else if (
                    fieldName in initialFormFields.current &&
                    fieldName in formFields.current &&
                    initialFormFields.current[fieldName].width === width &&
                    initialFormFields.current[fieldName].height === height &&
                    initialFormFields.current[fieldName].xAxis === xAxis &&
                    initialFormFields.current[fieldName].yAxis === yAxis &&
                    JSON.stringify(
                      initialFormFields.current[fieldName].styles
                    ) === JSON.stringify(styles) &&
                    JSON.stringify(
                      initialFormFields.current[fieldName].fieldProperties
                    ) === JSON.stringify(fieldProperties)
                  ) {
                    let existingFields = { ...formFields.current };
                    delete existingFields[oldFieldName];
                    formFields.current = { ...existingFields };
                  }
                } else if (
                  action === "delete" &&
                  isValidField &&
                  selectedFormFieldName.current.trim() ===
                    fieldName.toString().trim()
                ) {
                  if (fieldName in formFields.current) {
                    let fields = { ...formFields.current };
                    delete fields[fieldName];
                    formFields.current = { ...fields };
                  }
                  if (fieldName in initialFormFields.current && initialFormFields.current[fieldName].xAxis === xAxis && initialFormFields.current[fieldName].yAxis === yAxis) {
                    let existingFields = { ...initialFormFields.current };
                    delete existingFields[fieldName];
                    initialFormFields.current = { ...existingFields };
                    formFields.current = {
                      ...formFields.current,
                      [fieldName]: annotationProps,
                    };
                  }
                }
                props.unSavedFormFields.current =  formFields.current;
                instance.UI[
                  Object.keys(formFields.current).length > 0
                    ? "enableElements"
                    : "disableElements"
                ](["saveButton"]);
              }
            );

            documentViewer.addEventListener("documentLoaded", () => {
              instance.UI.disableElements(["saveButton"]);
            });

            instance.UI.setHeaderItems(function (header) {
              const headerItems = header.getHeader("default").getItems();
              zoomControls = headerItems[5];
              while (headerItems.length > 0) {
                header.getHeader("default").pop();
              }

              let formFields = header
                .getHeader("toolbarGroup-Forms")
                .getItems();
              let currentFormFields = formFields.slice(2, 7);
              currentFormFields.forEach((singleField) => {
                header.getHeader("default").push(singleField);
              });
              header.getHeader("default").push(formFields[0]);
              header.getHeader().push(zoomControls);
              header.getHeader().push({
                title: "Save file",
                type: "actionButton",
                img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>',
                dataElement: "saveButton",
                onClick: () => {
                  fieldSaveAction(instance);
                },
              });
            });

            // set the default toolbar group to the Shapes group
            //instance.UI.setToolbarGroup('toolbarGroup-Shapes');
          } else {
            instance.UI.disableElements([
              "ribbons",
              "viewControlsButton",
              "leftPanelButton",
              "searchButton",
              "toggleNotesButton",
              "menuButton",
              "selectToolButton",
              "panToolButton",
              "toolsHeader",
              "undoButton",
              "redoButton",
            ]);
          }
        });

          instance.UI.setTheme("light");
          const { Core } = instance;
          const { PDFNet } = Core;
          await PDFNet.initialize();
          docViewer = instance.Core.documentViewer;

          try {
            if (props.fileType === "pdf") {
              instance.UI.loadDocument(props.previewURL);
            } else {
              const buf = await instance.Core.office2PDFBuffer(
                props.previewURL,
                {
                  extension: props.fileType,
                }
              );
              const blob = new Blob([buf], { type: "application/pdf" });
              instance.UI.loadDocument(blob);
            }
          } catch (error) {
            instance.UI.loadDocument(props.previewURL, {
              extension: props.fileType,
              officeOptions: {
                formatOptions: {
                  hideTotalNumberOfPages: true,
                },
              },
            });
          }
          //instance.UI.loadDocument(props.previewURL); // sets it to the German locale
          //instance.Core.disableEmbeddedJavaScript();
          const UIEvents = instance.UI.Events;
          instance.UI.addEventListener(UIEvents.LOAD_ERROR, function (err) {
            setDocumentLoaded(false);
            if (err.detail.message !== "" || err.detail.type === "error") {
              instance.UI.showWarningMessage({
                message: t("TMF.TEXT_PREVIEWNOTAVAILABLE"),
              });
            }
          });
        });
      } else {
        var JSZip = require("jszip");
        fetch(props.previewURL)
          .then((res) => res.blob())
          .then((blob) => {
            JSZip.loadAsync(blob).then(function (zip) {
              let fileNameList = getPreviewFile(zip.files);
              setZipeList(fileNameList);
            }).catch(() => props.setIsErrorFile(true));
          });
        setDocumentLoaded(false);
      }
    } else if (props.fileType && customFileFormatTxt.includes(props.fileType)) {
        fetch(props.previewURL)
        .then((r) => r.text())
        .then((text) => {
          const isPlainText = /^[\x20-\x7E\n\r\t]*$/.test(text);
          if (isPlainText) {
          const content = document.querySelector(".content");
          content.innerText = text;
          } else {
            props.setIsErrorFile(true);
          }
        });
    } else if (props.fileType && customHTMLFormat.includes(props.fileType)) {
      fetch(props.previewURL)
        .then((r) => r.text())
        .then((text) => {
          HtmlContent = HtmlContent + text;
          setHtmlValue(HtmlContent);
        });
    } else if (props.fileType && customXMLFormat.includes(props.fileType)) {
        fetch(props.previewURL)
        .then((r) => r.text())
        .then((text) => {
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(text, "application/xml");
          const parseError = xmlDoc.querySelector("parsererror");
          if(!parseError) {
          const content = document.querySelector(".XML-content");
          content.innerText = text;
          } else {
            props.setIsErrorFile(true);
          }
        });
    }
  }, []);

  useEffect(() => {
    if (props.fileType && webviewUnsupportedFile?.includes(props.fileType.toLowerCase())) {
      if(!props.isErrorFile)
      setHeader();
     else setDocumentLoaded(false);
    }
  }, [props.fullDocument]);

  const setHeader = () => {
    setDocumentLoaded(false);
    const header = document.querySelector(".headerContent");
    const bmpImg = document.querySelector(".fullContent");
    const fileContentBlock = document.querySelector(".fileContentContainer");
    if(props.fileType.toLowerCase() === "bmp"){
      const bmpImgCustomStyle = {
        width:"100%",
        height: "100%",
      }
      Object.assign(bmpImg.style,bmpImgCustomStyle);
    }
    const headerCutomStyle = {
     height: !props.fullDocument ? "52px": "36px",
     background:"white",
     border: "0.5px solid #eaeaea",
    }
    const fileContentContainer = {
     width: props.fullDocument ? "98%" : "96%",
     height: "calc(-245px + 100vh)",
     overflow: props.fileType.toLowerCase() !== "bmp" ? "hidden auto" : ""
    }
    Object.assign(header.style,headerCutomStyle);
    Object.assign(fileContentBlock.style,fileContentContainer);
  }

  const renderUnsupportedErrorFile = () => {
    return (
      <div className="errorFileContainer">
        <viedoc-icon
          name="visibility_off"
          class="unsupport-preivew-icon"
        ></viedoc-icon>
        <p className="went-wrong">{t("TMF.TEXT_PREVIEWNOTAVAILABLE")}</p>
      </div>
    );
  };

  return (
    <>
      {documentLoaded && (
        <div className="webview-spinner">
          <viedoc-spinner size="small"></viedoc-spinner>
        </div>
      )}
      {
        props.isErrorFile && renderUnsupportedErrorFile()
      }
      { !props.isErrorFile && (
      props.fileType &&
      (clientFileFormat.includes(props.fileType) ||
        customFileFormatForTiff.includes(props.fileType)) &&
      props.fileType !== "zip" ? (
        <div className="pdf-preview">
          <div
            className="pdf-viewer"
            ref={viewer}
            style={{ height: "calc(100vh - 174px)" }}
          ></div>
        </div>
      ) : props.fileType && props.fileType.toLowerCase() === "tiff" ? (
        <div className="pdf-preview tiff">
          <img src={props.previewURL} />
        </div>
      ) : props.fileType && props.fileType.toLowerCase() === "bmp" ? (
        <div className="pdf-preview bmp-img">
          <div className="headerContent"></div>
          <div className="fileContentContainer">
          <img src={props.previewURL} className="fullContent" onError={()=>props.setIsErrorFile(true)}/>
          </div>
        </div>
      ) : props.fileType && customFileFormatTxt.includes(props.fileType) ? (
        <div className="pdf-preview txt-format">
          <div>
            <div className="headerContent"></div>
            <div className="fileContentContainer">
            <p className="content"></p>
            </div>
          </div>
        </div>
      ) : props.fileType && customXMLFormat.includes(props.fileType) ? (
        <div className="pdf-preview txt-format">
          <div>
            <div className="headerContent"></div>
            <div className="fileContentContainer">
            <p className="XML-content"></p>
            </div>
          </div>
        </div>
      ) : props.fileType && customHTMLFormat.includes(props.fileType) ? (
        <div className="pdf-preview">
          <div
            dangerouslySetInnerHTML={{ __html: htmlValue }}
            style={{ paddingTop: "25%", height: "85vh" }}
          />
        </div>
      ) : props.fileType && clientAviFormat.includes(props.fileType) ? (
        <div className="pdf-preview">
          <div className="pdf-viewer video-file" style={{ height: "90vh" }}>
            <div ref={viewer}></div>
          </div>
        </div>
      ) : props.fileType &&
        clientFileFormat.includes(props.fileType) &&
        props.fileType === "zip" ? (
        <div className="pdf-preview zip-folder">
          <div className="pdf-viewer">
          <div className="headerContent"></div>
          <div className="fileContentContainer">
            <div className="file-structure">
              <table className="zip-preview-heading">
                <thead>
                  <tr>
                    <th>
                      <span>{t("TMF.TEXT_NAME")}</span>
                    </th>
                    <th>
                      <span>{t("TMF.TEXT_DATEMODIFIED")}</span>
                    </th>
                    <th>
                      <span>{t("TMF.TEXT_TYPE")}</span>
                    </th>
                    <th>
                      <span>{t("TMF.TEXT_SIZE")}</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="zip-preview-body">
                  {zipList.length !== 0 &&
                    zipList.map((fileObject) => (
                      <tr>
                        <td title={fileObject.fileName}>
                          <i className={`sprite ${fileObject.fileIcon}`}></i>
                          <span>{fileObject.fileName}</span>
                        </td>
                        <td>
                          {fullDateTimePattern && fileObject.date
                            ? UtilsHelper.getFormattedDateTime(
                                fullDateTimePattern,
                                fileObject.date,
                                dateLocale
                              )
                            : fileObject.date}
                        </td>
                        <td title={fileObject.fileType}>
                          {fileObject.fileType}
                        </td>
                        <td>{fileObject.fileSize}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="pdf-preview" style={{ height: "85vh" }}>
          <iframe title={props.previewURL} src={props.previewURL}></iframe>
        </div>
      ))}
    </>
  );
};

export default WebView;
